let loaded = false;
const shareWidgetInit = async () => new Promise((resolve) => {

    if (loaded)
        resolve();

    const script = document.createElement('script');
    script.src = 'https://yastatic.net/share2/share.js';
    script.onload = () => {

        resolve();
        loaded = true;
    };

    document.body.appendChild(script);
});

/** lazy script loading */
setTimeout(() => shareWidgetInit(), /* run after 10s */ 10 * 1000);

document
    .querySelectorAll('[data-share]')
    .forEach((el) => {

        el.addEventListener('click', (e) => {

            e.preventDefault();

            if (el.showShare) {

                el.showShare();

                return;
            }

            el.setAttribute('disabled', 'disabled');
            shareWidgetInit().then(() => {

                const
                    shareElement = document.createElement('div'),
                    show = () => {
                        setTimeout(() => {
                            document.querySelector('.ya-share2__link_more').click();
                            document.querySelector('.ya-share2__item_service_telegram .ya-share2__title').innerText = 'Телеграм';
                            document.querySelector('.ya-share2__item_service_whatsapp .ya-share2__title').innerText = 'Ватсап';
                        }, 1);
                    };

                el.parentNode.insertBefore(shareElement, el);

                // eslint-disable-next-line no-undef
                Ya.share2(shareElement, {
                    theme: {
                        // bare: true,
                        shape: 'normal',
                        limit: 0,
                        moreButtonType: 'short',
                        services: 'vkontakte,telegram,odnoklassniki,whatsapp',
                        popupDirection: 'auto',
                        popupPosition: 'inner',
                        copy: 'first',
                        bare: true,
                    },
                    hooks: {
                        onready: () => {

                            // eslint-disable-next-line no-param-reassign
                            el.showShare = () => show();
                            show();

                            el.removeAttribute('disabled');
                        },
                    },
                });

            });

        });
    });